// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1PPk0","smText":"styles-module__smText___3MhHy"};